import { FC, useEffect } from 'react';
import { client } from '../../../services';
import { getProjectIdFromUrl } from '../../../utils/url';

/**
 * Starts the user's session when a page that needs it renders. Sessions are not started on
 * public pages, so a visit that begins on one and then moves to a signed-in page starts it
 * here. Renders nothing.
 */
const SessionStarter: FC = () => {
  useEffect(() => {
    client.ensureSession(getProjectIdFromUrl());
  }, []);

  return null;
};

export default SessionStarter;
